/**
 * 330 (FR-015, research R1) — the one definition of which cars a customer may see and book: those
 * whose pickup location is the customer's campus.
 *
 * 🔴 Constitution IV: the CASL Customer rule (`abilities.ts`) and the backend's query filter and
 * single-record check (`backend/src/shared/campusScope.ts`) all come from these two functions, so the
 * rule cannot be changed in one place and missed in another.
 *
 * Ids are compared as strings: a lean Mongo document carries an ObjectId, the user's campus may be a
 * string, and an ObjectId never `===` a string.
 */

type IdLike = { toString(): string } | string | null | undefined;

function idString(id: IdLike): string | null {
  if (id === null || id === undefined) return null;
  const s = String(id);
  return s === '' ? null : s;
}

/** The condition on a car for this campus, or `null` when there is no campus (no car matches). */
export function campusCarCondition(campusId: IdLike): { 'location.location_id': string } | null {
  const id = idString(campusId);
  return id ? { 'location.location_id': id } : null;
}

/** True when the car's pickup location is this campus. False with no campus, or a car with no location. */
export function carAtCampus(
  car: { location?: { location_id?: IdLike } | null },
  campusId: IdLike,
): boolean {
  const campus = idString(campusId);
  const at = idString(car.location?.location_id);
  return campus !== null && at !== null && campus === at;
}
